import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const userAffirmationProgramImporterSelectors = importerSelectors(
  'userAffirmationProgram.importer',
);

export default userAffirmationProgramImporterSelectors;
